export default "__VITE_ASSET__CJ8ZatZD__"